import { RotateCcwIcon } from 'lucide-react';

import { SearchUserInfo } from './search-user';
import styles from './search-user.module.scss';

type Props = {
    user: SearchUserInfo;
    onClear: () => void;
};

const SelectedUser = ({ user, onClear }: Props) => (
    <div className={styles.selectedUser}>
        <div className={styles.userInfo}>
            <span className={styles.name}>{user.name}</span>
            <span className={styles.email}>{user.email}</span>
        </div>
        <div className={styles.clearButton} onClick={onClear}>
            <RotateCcwIcon size={16} />
        </div>
    </div>
);

export { SelectedUser };
